<script>
export default {
    name: 'IlluEnseignant2',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-enseignant2"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M46.974 23.843a.628.628 0 00-.391.281l-6.025 9.78A19.434 19.434 0 0027.084 28.5c-4.31 0-8.294 1.398-11.522 3.767A19.54 19.54 0 008.525 42a19.54 19.54 0 007.038 9.734A19.412 19.412 0 0027.084 55.5c4.31 0 8.294-1.398 11.522-3.767a19.538 19.538 0 007.075-9.85l2.563-15.386c.142-.854-.096-1.721-1.27-2.654zM27.084 8.5c-2.07 0-3.946.84-5.303 2.197A7.477 7.477 0 0019.584 16c0 2.071.84 3.946 2.197 5.303a7.477 7.477 0 005.303 2.197c2.071 0 3.946-.84 5.304-2.197A7.477 7.477 0 0034.584 16c0-2.071-.84-3.946-2.196-5.303A7.477 7.477 0 0027.084 8.5z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <path
                d="M27 34c2.762 0 5 2.223 5 4.965V50h-3.61v-4.414h-2.778V50H22V38.965C22 36.223 24.24 34 27 34zm0 3.586c-.767 0-1.388.618-1.388 1.38v3.31h2.777v-3.31c0-.762-.622-1.38-1.389-1.38zM48 16v4h-8v-4h8zm8-8v4H40V8h16z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
